import React from 'react';
import classNames from 'classnames';

import {Layouts} from '@components';
import constants from '@constants';
import {Props} from './types';

import './index.scss';

const Main: React.FC<Props> = props => {
  const isAuthed = props.me.sub;

  return (
    <div className={classNames('a__questions-main', {after: isAuthed})}>
      {!isAuthed && (
        <Layouts.Header.Before
          history={props.history}
          location={props.location}
          match={props.match}
        />
      )}
      <div className="w__help">
        <div className="b__help-title">
          <span>よくある質問</span>
        </div>
        {constants.HELPS.qAndA.map((help: any, index: number) => {
          return (
            <div key={index}>
              <div className="b__help-item">
                <div className="b__item-question">
                  <span>{help.question}</span>
                </div>
                <div className="b__help-divier" />
                <div className="b__item-answer">
                  <span>{help.answer}</span>
                </div>
                <div className="b__item-answer">
                  <span>{help.answer1}</span>
                  {help.lists1 && (
                    <ol>
                      {help.lists1.map((help: any, index: number) => {
                        return <li key={index}>{help.process}</li>;
                      })}
                    </ol>
                  )}
                </div>
                <div className="b__item-answer">
                  <span>{help.answer2}</span>
                  {help.lists2 && (
                    <ol>
                      {help.lists2.map((help: any, index: number) => {
                        return <li key={index}>{help.process}</li>;
                      })}
                    </ol>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="w__footer">{!isAuthed && <Layouts.Footer.Main />}</div>
    </div>
  );
};

export default Main;
